// extracted by mini-css-extract-plugin
export default {"form":"CekotForm_form__pOQCN","control":"CekotForm_control__229FR","actions":"CekotForm_actions__nsfZm","submit":"CekotForm_submit__kstF2","invalid":"CekotForm_invalid__kz1P2"};